import apiClient from '../config/api';

class AuthService {
  // API 1: Login
  async login(email, password) {
    try {
      const response = await apiClient.post('/auth/login', {
        email,
        password,
      });

      const { user, token } = response.data.data;

      // FIXED: Store token and user data with error handling
      try {
        localStorage.setItem('auth_token', token);
        localStorage.setItem('user', JSON.stringify(user));
      } catch (storageError) {
        // If localStorage fails (e.g., in private browsing), continue anyway
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.warn('Failed to store auth data in localStorage:', storageError);
        }
      }

      return { user, token };
    } catch (error) {
      if (error.response?.status === 429) {
        throw new Error('Too many login attempts. Please try again later.');
      }
      // Handle both new error format (error.message) and legacy format (message)
      const errorMessage = error.response?.data?.error?.message || error.response?.data?.message || 'Login failed';
      throw new Error(errorMessage);
    }
  }

  // API 2: Register (Admin only)
  async register(userData) {
    try {
      const response = await apiClient.post('/auth/register', userData);
      return response.data.data;
    } catch (error) {
      const errorMessage = error.response?.data?.error?.message || error.response?.data?.message || 'Registration failed';
      throw new Error(errorMessage);
    }
  }

  // API 3: Logout
  async logout() {
    try {
      await apiClient.post('/auth/logout');
    } finally {
      // FIXED: Remove items with error handling
      try {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
      } catch (storageError) {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.warn('Failed to remove auth data from localStorage:', storageError);
        }
      }
    }
  }

  // API 4: Get current user
  async getCurrentUser() {
    try {
      const response = await apiClient.get('/auth/me');
      const user = response.data.data;
      // FIXED: Store user with error handling
      try {
        localStorage.setItem('user', JSON.stringify(user));
      } catch (storageError) {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.warn('Failed to store user data in localStorage:', storageError);
        }
      }
      return user;
    } catch (error) {
      throw new Error('Failed to fetch user data');
    }
  }

  // FIXED: Check if user is authenticated with error handling
  isAuthenticated() {
    try {
      return !!localStorage.getItem('auth_token');
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.warn('Failed to check authentication from localStorage:', error);
      }
      return false;
    }
  }

  // FIXED: Get stored user with error handling
  getUser() {
    try {
      const userStr = localStorage.getItem('user');
      return userStr ? JSON.parse(userStr) : null;
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.warn('Failed to get user from localStorage:', error);
      }
      return null;
    }
  }

  // Check user role
  isAdmin() {
    const user = this.getUser();
    return user?.role === 'admin';
  }

  isWorkerOrHigher() {
    const user = this.getUser();
    return user?.role === 'admin' || user?.role === 'worker';
  }
}

export default new AuthService();
